import React from 'react'
import { PremiumGate } from 'components/payments/Gates'
import { IconPickerConfig } from 'components/Customize/Styling/IconPicker/Constants'
import PremiumOverlay from 'components/shared/PremiumOverlay'
import IconSVG from 'svg-inline-react'
import './style.styl'

const GatedIconPicker = ({ iconStyle }) => (
  <div className="GatedIconPicker-container">
    <PremiumOverlay className="GatedIconPicker" >
      <div className="upgrade-prompt">
        <div className="IconPickerWidget">
            <IconSVG src={IconPickerConfig[iconStyle].chatSrc} />
        </div>
        <div className="upgrade-prompt-text-container">
          <div className="upgrade-prompt-text">Brand your</div><div className="upgrade-prompt-text">chat widget…</div>
        </div>
      </div>
      <div className="CustomIconPicker">
        <div>Make your widget your own</div>
        <div>with a custom image or logo!</div>
      </div>
    </PremiumOverlay>
  </div>
)

export default GatedIconPicker


// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Styling/GatedIconPicker/index.js